module.exports = {
    back: 'Voltar',
    allCourses: 'Todos os cursos',
    instruction: 'Aqui você pode acessar todos os cursos criados por você.',
    noCourses: 'Você não possui cursos! Crie um agora mesmo voltando para a página inicial.',
}